// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh4[data-v-0f66328f] {\r\n  padding-left: 22px;\r\n  margin: 10px 0 2px;\r\n  color: #5ab1ef;\n}\n.top[data-v-0f66328f] {\r\n  margin-top: -15px;\n}\n.yuliang[data-v-0f66328f] {\r\n  margin-left: 130px;\r\n  color: red;\n}\n.top_tu[data-v-0f66328f] {\r\n  margin-top: -10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
